const REGISTRATION_STATUS = {
    BRAND_NOT_CREATED: 'BRAND_NOT_CREATED',
    BRAND_ERROR_IN_CREATION: 'BRAND_ERROR_IN_CREATION',
    BRAND_CREATED_NOT_VERIFIED: 'BRAND_CREATED_NOT_VERIFIED',
    BRAND_VERIFIED_CAMPAIGN_NOT_CREATED: 'BRAND_VERIFIED_CAMPAIGN_NOT_CREATED',
    BRAND_VERIFIED_CAMPAIGN_CREATED_NOT_ACTIVATED: 'BRAND_VERIFIED_CAMPAIGN_CREATED_NOT_ACTIVATED',
    BRAND_VERIFIED_BILLING_CAMPAIGN_PURCHASED_CAMPAIGN_UPDATES_REQUIRED: 'BRAND_VERIFIED_BILLING_CAMPAIGN_PURCHASED_CAMPAIGN_UPDATES_REQUIRED',
    CAMPAIGN_ERROR_IN_CREATION: 'CAMPAIGN_ERROR_IN_CREATION',
    BRAND_VERIFIED_CAMPAIGN_ACTIVATED_WAITING_FOR_MIGRATION: 'BRAND_VERIFIED_CAMPAIGN_ACTIVATED_WAITING_FOR_MIGRATION',
    CAMPAIGN_ERROR_IN_BILLING: 'CAMPAIGN_ERROR_IN_BILLING',
    CAMPAIGN_ERROR_IN_BILLING_GW_EXCEPTION: 'CAMPAIGN_ERROR_IN_BILLING_GW_EXCEPTION',
    BRAND_ERROR_IN_BILLING: 'BRAND_ERROR_IN_BILLING',
    BRAND_ERROR_IN_BILLING_GW_EXCEPTION: 'BRAND_ERROR_IN_BILLING_GW_EXCEPTION',
    BRAND_CREATED_NOT_VERIFIED_PERMANENTLY: 'BRAND_CREATED_NOT_VERIFIED_PERMANENTLY',
    BILLING_BRAND_PURCHASED_NEED_RESUBMIT: 'BILLING_BRAND_PURCHASED_NEED_RESUBMIT',
    BILLING_BRAND_PURCHASED_BRAND_NOT_CREATED: 'BILLING_BRAND_PURCHASED_BRAND_NOT_CREATED',
    APPROVED: 'APPROVED',
    BRAND_DELETED: 'BRAND_DELETED',
    WAITING_FOR_MAIN_ACCOUNT_APPROVAL: 'WAITING_FOR_MAIN_ACCOUNT_APPROVAL',
    FOLLOWER_ACCOUNT_WAITING_FOR_NUMBERS_PROVIDER: 'FOLLOWER_ACCOUNT_WAITING_FOR_NUMBERS_PROVIDER',
    BRAND_VERIFIED_BILLING_CAMPAIGN_PURCHASED_CAMPAIGN_TERMINATED: 'BRAND_VERIFIED_BILLING_CAMPAIGN_PURCHASED_CAMPAIGN_TERMINATED',
    NUMBER_POOLING_ACTIVATED_WAITING_FOR_APPROVED_FROM_SINCH: 'NUMBER_POOLING_ACTIVATED_WAITING_FOR_APPROVED_FROM_SINCH',
    APPROVED_OLD_CAMPAIGN_NEEDS_UPDATE: 'APPROVED_OLD_CAMPAIGN_NEEDS_UPDATE',
    APPROVED_OLD_CAMPAIGN_UPDATED_FROM_CLIENT : 'APPROVED_OLD_CAMPAIGN_UPDATED_FROM_CLIENT',
    APPROVED_REGISTRATION_NEEDS_UPDATE: 'APPROVED_REGISTRATION_NEEDS_UPDATE',
    APPROVED_REGISTRATION_UPDATED_FROM_CLIENT: 'APPROVED_REGISTRATION_UPDATED_FROM_CLIENT',
    APPROVED_REGISTRATION_UPDATES_REQUIRED: 'APPROVED_REGISTRATION_UPDATES_REQUIRED',
    CAMPAIGN_TERMINATED_AFTER_APPROVAL_BILLING_CANCELLATION_REQUIRED : 'CAMPAIGN_TERMINATED_AFTER_APPROVAL_BILLING_CANCELLATION_REQUIRED',
    CAMPAIGN_TERMINATED_AFTER_APPROVAL : 'CAMPAIGN_TERMINATED_AFTER_APPROVAL'
};

const FAILURE_REGISTRATION_STATUS = [
    REGISTRATION_STATUS.BRAND_ERROR_IN_CREATION, REGISTRATION_STATUS.BRAND_CREATED_NOT_VERIFIED_PERMANENTLY,
    REGISTRATION_STATUS.CAMPAIGN_ERROR_IN_CREATION, REGISTRATION_STATUS.BRAND_DELETED
];

const PENDING_REGISTRATION_STATUS = [
    REGISTRATION_STATUS.BRAND_NOT_CREATED, REGISTRATION_STATUS.BRAND_CREATED_NOT_VERIFIED, REGISTRATION_STATUS.BRAND_VERIFIED_CAMPAIGN_NOT_CREATED,
    REGISTRATION_STATUS.BRAND_VERIFIED_CAMPAIGN_CREATED_NOT_ACTIVATED, REGISTRATION_STATUS.BRAND_VERIFIED_CAMPAIGN_ACTIVATED_WAITING_FOR_MIGRATION
];

const APPROVED_REGISTRATION_ACTION_REQUIRED_STATUS = [
    REGISTRATION_STATUS.APPROVED_REGISTRATION_NEEDS_UPDATE,
    REGISTRATION_STATUS.APPROVED_REGISTRATION_UPDATES_REQUIRED,
];

const ACTION_REQUIRED_STATUS = [
    REGISTRATION_STATUS.BRAND_ERROR_IN_BILLING, REGISTRATION_STATUS.BRAND_VERIFIED_BILLING_CAMPAIGN_PURCHASED_CAMPAIGN_UPDATES_REQUIRED,
    REGISTRATION_STATUS.CAMPAIGN_ERROR_IN_BILLING_GW_EXCEPTION, REGISTRATION_STATUS.CAMPAIGN_ERROR_IN_BILLING, REGISTRATION_STATUS.BRAND_ERROR_IN_BILLING_GW_EXCEPTION
];

const REJECTED_REGISTRATION_STATUS = [
    REGISTRATION_STATUS.BRAND_VERIFIED_BILLING_CAMPAIGN_PURCHASED_CAMPAIGN_TERMINATED
];

const TERMINATED_REGISTRATION_STATUS = [
    REGISTRATION_STATUS.CAMPAIGN_TERMINATED_AFTER_APPROVAL_BILLING_CANCELLATION_REQUIRED,
    REGISTRATION_STATUS.CAMPAIGN_TERMINATED_AFTER_APPROVAL,
];

const APPROVED_REGISTRATION_STATUS = [
    REGISTRATION_STATUS.APPROVED, REGISTRATION_STATUS.BRAND_VERIFIED_CAMPAIGN_ACTIVATED_WAITING_FOR_MIGRATION, REGISTRATION_STATUS.APPROVED_OLD_CAMPAIGN_UPDATED_FROM_CLIENT
];

const SP_NUMBER_SELECTION_APPROVED_STATUSES = APPROVED_REGISTRATION_STATUS;

const BRAND_ENTITY_TYPES = {
    SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
};

const OLD_CAMPAIGN_STATUS = [
    REGISTRATION_STATUS.APPROVED_OLD_CAMPAIGN_NEEDS_UPDATE,
];

const CANCELLED_REGISTRATION_STATUS = [
    'CANCELED'
];

const REGISTER_STEP_FORM_TYPE = {
    EDIT_APPROVED_REGISTRATION: 'editApprovedRegistration',
    UPDATES_REQUIRED: "updatesRequired",
    QUICK_FLOW: "quickFlow"
}

export {
    REGISTRATION_STATUS,
    FAILURE_REGISTRATION_STATUS,
    PENDING_REGISTRATION_STATUS,
    ACTION_REQUIRED_STATUS,
    REGISTER_STEP_FORM_TYPE,
    REJECTED_REGISTRATION_STATUS,
    TERMINATED_REGISTRATION_STATUS,
    CANCELLED_REGISTRATION_STATUS,
    APPROVED_REGISTRATION_STATUS,
    SP_NUMBER_SELECTION_APPROVED_STATUSES,
    BRAND_ENTITY_TYPES,
    OLD_CAMPAIGN_STATUS,
    APPROVED_REGISTRATION_ACTION_REQUIRED_STATUS,
};
